module.exports = __webpack_public_path__ + "static/media/legend.a232c8b4.svg";